import "./style.css";
import ReactDOM from "react-dom/client";
import CanvasExperience from "./components/CanvasExperience";
import TargetInfo from "./components/TargetInfo/TargetInfo";
import Descriptor from "./components/Descriptor/Descriptor";
import ViewContextProvider from "./providers/View.provider";
import Navigation from "./components/Navigation/Navigation";
import { Suspense } from "react";

const root = ReactDOM.createRoot(document.querySelector("#root"));

root.render(
  <ViewContextProvider>
    <main>
      <noscript> You need to enable JavaScript to run this app. </noscript>
      <Descriptor />
      <Suspense
        fallback={
          <div className="fixed right-0 h-full items-center z-50 w-3/4 flex justify-center text-3xl">
            <span class="loader">Load&nbsp;ng</span>
          </div>
        }
      >
        <CanvasExperience />
      </Suspense>
      <Navigation />
      <TargetInfo />
    </main>
  </ViewContextProvider>
);
